<div class="alert-message-container">
  <h3>Autentique Alert Message 'Generator'</h3>

  <div class="alert-option">
    <label for="size">Size:</label>
    <select id="size" [(ngModel)]="size" (change)="onSizeChange()">
      <option value="S">Small</option>
      <option value="M">Medium</option>
    </select>
  </div>

  <div class="alert-option">
    <label for="type">Type:</label>
    <select id="type" [(ngModel)]="type" (change)="onTypeChange()">
      <option value="default">Default</option>
      <option value="warning">Warning</option>
      <option value="success">Success</option>
      <option value="error">Error</option>
    </select>
  </div>

  <div class="alert-option alert-option--checkbox">
    <label for="hasTitle">Include Title:</label>
    <input type="checkbox" id="hasTitle" [(ngModel)]="hasTitle" (change)="onTitleToggle()" />
  </div>

  <div *ngIf="hasTitle">
    <label for="title">Title:</label>
    <input type="text" id="title" [(ngModel)]="title" (change)="onTitleChange()" placeholder="Alert title" />
  </div>

  <div>
    <label for="text">Text:</label>
    <textarea id="text" [(ngModel)]="text" (change)="onTextChange()" rows="3"></textarea>
  </div>

  <div class="preview">
    <p class="preview__label">PREVIEW:</p>
    <div [class]="alertClasses">
      <i class="fa-regular fa-circle-info"></i>
      <div>
        <p *ngIf="hasTitle && title" class="alertMessage__title">{{ title }}</p>
        <span>{{ text }}</span>
      </div>
    </div>
  </div>

  <div class="value">
    <textarea class="value-show" readonly #codeTextarea>{{ htmlCode }}</textarea>
    <a class="value-copy text-decoration-none" [ngxClipboard]="codeTextarea"></a>
  </div>
</div>
